import { useCallback } from 'react';
import { useHistory } from 'react-router';
import { useAuthToken } from '@tribeplatform/react-sdk/hooks';
import { getIsInternal, getLinkFeatures, getLinkTarget, parseHref, } from '../utils';
export const useNavigate = () => {
    const { data: { networkPublicInfo }, } = useAuthToken();
    const history = useHistory();
    const navigate = useCallback((href, target) => {
        const parsedHref = parseHref(href, networkPublicInfo);
        const isInternal = getIsInternal(parsedHref);
        const linkTarget = getLinkTarget(target, isInternal);
        const windowFeatures = getLinkFeatures(linkTarget);
        if (linkTarget === '_blank') {
            window.open(parsedHref, linkTarget, windowFeatures);
            return;
        }
        if (isInternal) {
            history.push(parsedHref);
            return;
        }
        window.open(parsedHref, linkTarget, windowFeatures);
    }, [history, networkPublicInfo]);
    return navigate;
};
//# sourceMappingURL=useNavigate.js.map